import React from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";

export default function AdminRoute({ children, allowManager = false }) {
  const isAuthenticated = !!localStorage.getItem("access_token");
  const { isAdmin, isManager } = useAuth();

  if (!isAuthenticated) return <Navigate to="/login" replace />;
  const allowed = isAdmin || (allowManager && isManager);
  if (!allowed) return <Navigate to="/dashboard" replace />;
  return children;
}
